import React from 'react'
import { formatMoney, formatPercentage } from '../../packages/utils/numberFormatters'
import { useTranslation } from 'react-i18next'

export const formatWarrantSubPrice = (warrant, locale, currency) => {
    if (!warrant) return ''

    const subPeriod = warrant.currentSubscriptionPeriod
    const warrantSubPrice = subPeriod?.warrantSubPrice

    return warrantSubPrice ? (
        formatMoney(warrantSubPrice, { locale, currencySymbol: currency, minDecimals: 2, maxDecimals: 5 })
    ) : (
        <div>
            <div>VWAP-rabatt: {formatPercentage(subPeriod?.vwapDiscount, { locale, minDecimals: 0 })}</div>
            <div>
                Min:{' '}
                {formatMoney(subPeriod?.priceMin, {
                    locale,
                    currencySymbol: currency,
                    minDecimals: 2,
                    maxDecimals: 5,
                }) || 'Kvotvärde'}
                {subPeriod?.priceMax && (
                    <>
                        , Max:{' '}
                        {formatMoney(subPeriod?.priceMax, {
                            locale,
                            currencySymbol: currency,
                            minDecimals: 2,
                            maxDecimals: 5,
                        })}
                    </>
                )}
            </div>
        </div>
    )
}

export function WarrantSubPrice({ warrant }) {
    const { i18n } = useTranslation()
    const locale = i18n.language

    return <>{formatWarrantSubPrice(warrant, locale)}</>
}
